import { Injectable } from '@angular/core';
import { confirm } from 'devextreme/ui/dialog';

@Injectable({ providedIn: 'root' })
export class CanDeactivateService {
  canDeactivate(message: string, title: string): Promise<boolean> {
    return confirm(message, title);
  }
}
